import { render, staticRenderFns } from "./PageNotFoundModule.vue?vue&type=template&id=bdafe0fc&"
import script from "./PageNotFoundModule.vue?vue&type=script&lang=js&"
export * from "./PageNotFoundModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports